import * as React from 'react'
import './checkbox.css'

class Checkbox extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    toggleCheckboxChange = () => {
        const { handleCheckboxChange } = this.props
        handleCheckboxChange()
    }

    render() {
        const { id, checked } = this.props

        return (
            <div className="checkbox">
                <input
                    id={id}
                    type="checkbox"
                    checked={checked}
                    onChange={this.toggleCheckboxChange}
                />
                <label htmlFor={id} />
            </div>
        )
    }
}

export default Checkbox


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Checkbox/index.tsx